export const initialState = {
    is_loading: true,
    ftms: [],
    page_number: 1,
    selected_ftm: {},
    is_open_previous_details: false,
    serach_text: '',
    ftm_stages: [],
    filter_option: "",
    sort_key: '',
    sort_direction: '',
    is_date_search: false
}